
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "job-configuration-card",
  setup: function() {
    const sendJobEmail = ref<boolean>(false);

    function getSendJobMail(): boolean {
      return sendJobEmail.value;
    }

    return {
      getSendJobMail,
      sendJobEmail
    };
  }
});
